import React from 'react';
export function getJoySpacePageLink(joyspaceHost, data) {
    var linkType = 'page';
    switch (data.pageType) {
        case '1':
            linkType = 'page';
            break;
        case '2':
            linkType = 'report';
            break;
        case '3':
            linkType = 'page';
            break;
        case '4':
            linkType = 'sheet';
            break;
        case '5':
            linkType = 'page';
            break;
        case '6':
            linkType = 'file';
            break;
        case '7':
            linkType = 'websheet';
            break;
        default:
    }
    return joyspaceHost + "/" + linkType + "/" + data.id;
}
export default function getHighlightComp(highlight, name, defualtStrValue) {
    if (!highlight.length) {
        return defualtStrValue || '';
    }
    var hl = highlight.find(function (item) { return item.name === name; });
    if (!hl) {
        return defualtStrValue || '';
    }
    var comps = [];
    var idx = 0;
    var key = hl.key, value = hl.value;
    // @ts-ignore
    value.replace(new RegExp(key, 'g'), function (a, i) {
        comps.push(React.createElement("span", { key: i }, value.slice(idx, i)));
        comps.push(React.createElement("span", { key: i + "-1", className: "color-primary" }, value.slice(i, i + key.length)));
        idx = i + key.length;
    });
    comps.push(React.createElement("span", { key: idx + "-last" }, value.slice(idx)));
    return (React.createElement("div", { style: {
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '100%',
        } }, comps));
}
export function getTelHighlightComp(telHighlight) {
    if (!telHighlight) {
        return '';
    }
    return React.createElement(React.Fragment, null,
        "\u5EA7\u673A\u53F7\uFF1A",
        getHighlightComp([telHighlight], 'titleList.telephone'));
}
export function getHighlightCompWithLabel(label, highlight, key) {
    if (!highlight) {
        return '';
    }
    return (React.createElement("div", { style: {
            direction: 'ltr',
            display: 'flex',
            alignItems: 'center',
        } },
        label,
        "\uFF1A",
        getHighlightComp([highlight], key)));
}
export function convertUIDToString(uid) {
    return uid.pin + ":" + uid.app + ":" + uid.teamId;
}
export function parseUidFromString(id) {
    var seeds = id.split(':');
    return {
        pin: seeds[0],
        app: seeds[1],
        teamId: seeds[2],
    };
}
export function listItemToUid(item) {
    return {
        app: item.app,
        pin: item.pin,
        teamId: item.teamId,
    };
}
// 根据判断是不是gif图片
export function isGifImage(url) {
    if (!url)
        return false;
    var _a = url.split('?'), partI = _a[0], partII = _a[1];
    var ext = partI.substring(partI.lastIndexOf('.') + 1);
    return ext.toLocaleLowerCase() === 'gif';
}
export function getUserInfo() {
    var params = new URLSearchParams(window.location.href);
    return {
        accessToken: params.get('accessToken'),
        appKey: params.get('appKey'),
    };
}
/**
 * 获取头像缩略图
 * @param url
 * @param thumbWidth
 * @param thumbHeight
 * @returns
 */
export var getHeadImgThumbUrl = function (url, thumbWidth, thumbHeight, isWebpSupported
// eslint-disable-next-line max-params
) {
    // 已是缩略图
    if (!url) {
        return '';
    }
    if (/-\d+_\d+\?/.test(url)) {
        if (url.lastIndexOf('?') > -1) {
            return "" + url + (isWebpSupported ? '' : '&imageType=png');
        }
        else {
            return url;
        }
    }
    if (url.indexOf('eefs') > -1) {
        if (url.lastIndexOf('?') > -1) {
            var _a = url.split('?'), partI = _a[0], partII = _a[1];
            if (isGifImage(url)) {
                return partI + "?" + partII + "&ver=2";
            }
            return partI + "-" + thumbWidth + "_" + thumbHeight + "?" + partII + "&ver=2";
        }
        else {
            if (isGifImage(url)) {
                return url + "?ver=2";
            }
            return url + "-" + thumbWidth + "_" + thumbHeight + "?ver=2";
        }
    }
    return url;
};
//# sourceMappingURL=utils.js.map